import { localize } from "@gtmhub/localization";

export function sessionStatus() {
  return function (text: string) {
    if (text === "open") {
      return localize("open");
    }

    if (text === "closed") {
      return localize("archived");
    }

    return localize("in_progress");
  };
}
